const vianavigoItineraryScript = function (token, configId) {
  window.vianavigo.token = token
  window.vianavigo.itinerary("#mon_selecteur", configId, "portrait")
  window.vianavigo.override_base_url = "https://mb-api-iv.iledefrance-mobilites.fr/"
  window.vianavigo.override_external_base = "https://mb-iv.iledefrance-mobilites.fr/"
}

export default vianavigoItineraryScript
